import React, { useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import PersonalInfoForm from "../forms/PersonalInfoForm";
import BioForm from "../forms/BioForm";
import SocialForm from "../forms/SocialForm";
import "../../account/AccountPage.css";
import { formatNigerianPhone } from "../../../utils/formatters";
import BioDisplay from "../../../components/bioDisplay/BioDisplay";
import IdentityVerificationCard from "../../../components/identityVerification/IdentityVerificationCard";

const TutorAbout = ({ user, setStatusModal }) => {
  // console.log("User in about section:", user);

  const [editing, setEditing] = useState({
    personal: false,
    bio: false,
    social: false,
  });

  const toggleEdit = (section) => {
    setEditing((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const platformIcons = {
    x: "𝕏",
    instagram: "📸",
    facebook: "📘",
    linkedin: "💼",
  };

  return (
    <>
      <IdentityVerificationCard setStatusModal={setStatusModal} />
      <div className="about-wrapper">
      {/* PERSONAL INFO */}
      <div className="account-profile-card">
        <div className="account-profile-header">
          <h3>Personal Information</h3>

          {!editing.personal && (
            <button onClick={() => toggleEdit("personal")} className="edit-btn">
              ✏️ Edit
            </button>
          )}
        </div>

        {editing.personal ? (
          <PersonalInfoForm
            onCancel={() => toggleEdit("personal")}
            setStatusModal={setStatusModal}
          />
        ) : (
          <div className="info-grid">
            <div className="info-item">
              <span>First Name</span>
              <p>{user?.firstName}</p>
            </div>

            <div className="info-item">
              <span>Last Name</span>
              <p>{user?.lastName}</p>
            </div>

            <div className="info-item">
              <span>Gender</span>
              <p>{user?.gender}</p>
            </div>

            <div className="info-item">
              <span>Email</span>
              <p>{user?.email}</p>
            </div>

            <div className="info-item">
              <span>Phone</span>
              <p>{formatNigerianPhone(user?.phone)}</p>
            </div>
          </div>
        )}
      </div>

      {/* BIO */}
      <div className="account-profile-card">
        <div className="account-profile-header">
          <h3>Bio</h3>

          {!editing.bio && (
            <button onClick={() => toggleEdit("bio")} className="edit-btn">
              ✏️ Edit
            </button>
          )}
        </div>

        {editing.bio ? (
          <BioForm
            onCancel={() => toggleEdit("bio")}
            setStatusModal={setStatusModal}
          />
        ) : (
          <BioDisplay provider={user} />
        )}
      </div>

      {/* SOCIAL */}
      <div className="account-profile-card">
        <div className="account-profile-header">
          <h3>Social Media</h3>

          {!editing.social && (
            <button onClick={() => toggleEdit("social")} className="edit-btn">
              ✏️ Edit
            </button>
          )}
        </div>

        {editing.social ? (
          <SocialForm
            onCancel={() => toggleEdit("social")}
            setStatusModal={setStatusModal}
          />
        ) : (
          <div className="info-grid">
            <div className="info-item">
              <span>Platform</span>
              <p>
                {user?.socialMedia?.platform &&
                  platformIcons[user?.socialMedia?.platform]}
                {user?.socialMedia?.platform || "-"}
              </p>
            </div>

            <div className="info-item">
              <span>Link</span>
              <p>
                {user?.socialMedia?.link ? (
                  <a
                    href={user.socialMedia.link}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {user.socialMedia.link}
                  </a>
                ) : (
                  "-"
                )}
              </p>
            </div>
          </div>
        )}
      </div>
      </div>
    </>
  );
};

export default TutorAbout;
